import React from 'react';
import { Navigate, Route } from 'react-router-dom';
import { Routes as Routess } from 'react-router-dom';
import LoyaltyStore from './pages/LoyaltyStore';

//pages
import PrivateRoute from 'components/PrivateRoute';
// import BenefitOld from 'pages/Contract/ClaimOnline/Old/Benefit';
import Layout from 'components/layout/index';
import useDevice from 'hooks/useDevice';
import Login from 'pages/auth/Login';
import DetailGiftCategory from 'pages/DetailGiftCategory';

const Routes = ({ isVtStore, isPartnerLink }) => {
  const { isMobile } = useDevice();
  return (
    <Layout isPartnerLink={isPartnerLink} isVtStore={isVtStore}>
      <Routess>
        <Route path='*' element={<Navigate to='/' replace />} />
        <Route path='/' element={<PrivateRoute isAuthRoute={true} component={<div />} />} />
        {/* <Route path='/login' element={<PrivateRoute component={<Login />} />} /> */}
        <Route
          path={'/pages/loyalty-store'}
          element={<PrivateRoute component={<LoyaltyStore isMobile={isMobile} />} />}
        />

        <Route
          path={'/pages/loyalty-store/detail'}
          element={<PrivateRoute component={<DetailGiftCategory />}/>}
        />
      </Routess>

    </Layout>
  );
};

export default Routes;
